export const DATA_TYPE = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  LIST: 'LIST',
  DATE: 'DATE',
  ADDRESS: 'ADDRESS',
  // todo coming soon
  // COLOR: 'color',
  // FILE: 'file'
};

export const WIDGET = {
  // TEXT
  INPUT: 'INPUT',
  TEXTAREA: 'TEXTAREA',
  PASSWORD: 'PASSWORD',
  // DATE
  DATE_PICKER: 'DATE_PICKER',
  TIME_PICKER: 'TIME_PICKER',
  // NUMBER
  NUMBER: 'NUMBER',
  RATE: 'RATE',
  SLIDER: 'SLIDER',
  DECIMAL: 'DECIMAL',
  PRICE: 'PRICE',
  PERCENT: 'PERCENT',
  // BOOLEAN
  CHECKBOX: 'CHECKBOX',
  SWITCH: 'SWITCH',
  // LIST
  SELECT: 'SELECT',
  RADIO_GROUP: 'RADIO_GROUP',
  CHECKBOX_GROUP: 'CHECKBOX_GROUP',
  BUTTON: 'BUTTON',
};

export const WIDGET_GROUP = {
  [DATA_TYPE.TEXT]: [
    WIDGET.INPUT,
    WIDGET.TEXTAREA,
    WIDGET.PASSWORD,
  ],
  [DATA_TYPE.NUMBER]: [
    WIDGET.NUMBER,
    WIDGET.RATE,
    WIDGET.DECIMAL,
    WIDGET.PRICE,
    WIDGET.PERCENT,
  ],
  [DATA_TYPE.BOOLEAN]: [
    WIDGET.CHECKBOX,
    WIDGET.SWITCH,
  ],
  [DATA_TYPE.LIST]: [
    WIDGET.SELECT,
    WIDGET.RADIO_GROUP,
    WIDGET.CHECKBOX_GROUP,
    WIDGET.BUTTON,
  ],
  [DATA_TYPE.DATE]: [
    WIDGET.DATE_PICKER,
    WIDGET.TIME_PICKER,
  ],
};

export const RULES = {
  REQUIRED: 'REQUIRED',
  EMAIL: 'EMAIL',
  PHONE_NUMBER: 'PHONE_NUMBER',
  NAME: 'NAME',
  TEXT: 'TEXT',
  ADDRESS: 'ADDRESS',
  ZIPCODE: 'ZIPCODE',
  LESS_THAN: 'LESS_THAN',
  GREATER_THAN: 'GREATER_THAN',
  CI: 'CI',
};

export const RULES_GROUP = {
  [DATA_TYPE.TEXT]: [
    RULES.REQUIRED,
    RULES.EMAIL,
    RULES.PHONE_NUMBER,
    RULES.NAME,
    RULES.TEXT,
    RULES.ZIPCODE,
    RULES.CI,
  ],
  [DATA_TYPE.NUMBER]: [
    RULES.REQUIRED,
    RULES.LESS_THAN,
    RULES.GREATER_THAN,
  ],
  [DATA_TYPE.BOOLEAN]: [
    RULES.CHECKBOX,
    RULES.SWITCH,
  ],
  [DATA_TYPE.LIST]: [
    RULES.REQUIRED,
  ],
  [DATA_TYPE.DATE]: [
    RULES.REQUIRED,
  ],
  [DATA_TYPE.ADDRESS]: [
    RULES.REQUIRED,
    RULES.ADDRESS,
  ],
};
